import React from "react";
import { motion } from "framer-motion";
import {
  MapPin,
  Clock,
  DollarSign,
  Star,
  Mountain,
  Camera,
  TreePine
} from "lucide-react";
import "./Attractions.css";

const Attractions: React.FC = () => {
  const attractions = [
    {
      name: "Sevier Valley Coffee Co.",
      description:
        "Located right next door to the hotel. Quite possibly the best coffee products in the state.  Wonderful people.",
      distance: "1 minute",
      duration: "",
      cost: "",
      rating: 4.8,
      image: 'https://b8aab2f4f459ff7a2030.cdn6.editmysite.com/uploads/b/b8aab2f4f459ff7a203036d7c831cf4d7d302486d4894cf306ca05893fda1a4e/Untitled%20design%20%283%29_1736445791.png?width=2400&optimize=medium',
      features: ['Breakfast', 'Coffee', 'Gift Shop', 'Souvenirs'],
      url: "https://www.seviervalleycoffee.com/#MON243DFQOG6IASYAKQQZHDM"
    },
    {
      name: "Mom's Cafe",
      description:
        "Mom's Cafe Great homestyle dining.  Breakfast, Lunch and Dinner.",
      distance: "1 minute",
      duration: "1-2 hours",
      cost: "",
      rating: 4,
      image: 'https://live.staticflickr.com/2207/2146928808_c02356095d_b.jpg',
      features: ['Great Food', 'Home Style Cooking', 'Great Service'],
      url: "https://www.facebook.com/momscafesalina/"
    },
    {
      name: "The Hot Spot",
      description:
        "Old fashioned fast food.  Burgers, shakes and fries and a ton of other great things on the menu",
      distance: "1 minutes",
      duration: "30 minutes",
      cost: "",
      rating: 4,
      image: 'https://www.utahsadventurefamily.com/wp-content/uploads/2018/05/The-Hot-Spot-5-scaled.jpg',
      features: ['Great Food', 'Fast Food', 'Great Service'],
      url: "https://www.facebook.com/hotspotsalina/"
    },
    {
      name: "Eyes to the Sky Balloon Festival",
      description: (
        <>
          A world class hot air balloon event June 20th - 22th 2025{' '}
          <a
            href="https://eyestotheskyballoonfestival.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0077cc", textDecoration: "underline" }}
          >
            eyestotheskyballoonfestival.com
          </a>
        </>
      ),
      distance: "1 minute",
      duration: "3-4 hours",
      cost: "",
      rating: 4,
      image: 'https://i0.wp.com/wolfharttimages.com/wp-content/uploads/2021/04/Salina-06.jpg?resize=1024%2C683&ssl=1',
      features: ['Fun', 'Family', 'Food', 'Music'],
      url: "https://eyestotheskyballoonfestival.com"
    },
    {
      name: "Miss Mary's Historical Museum",
      description:
        "Historical museum of Salina, and surrounding area. \n\n(By reservation only!)\nCall (435) 529-4108",
      distance: "1 minute",
      duration: "",
      cost: "Free",
      rating: 5,
      image:
        "https://nowplayingutah.com/wp-content/uploads/sites/nowplayingutah.com/images/venue/65415/missmaryshistoricalmuseum_venueimage.jpg",
      features: ["History", "Cultural", "Free Entry"],
      url: "https://www.facebook.com/missmarysmuseum/"
    },
    {
      name: "WWII POW Camp Salina Museum",
      description:
        "A preserved WWII-era POW camp turned museum, showcasing photos, memorabilia, and the site's unique history.",
      distance: "1 minute",
      duration: "30-60 minutes",
      cost: "Free",
      rating: 5,
      image: 'https://scontent-den2-1.xx.fbcdn.net/v/t39.30808-6/475336710_1043820497779857_9021916500152638051_n.jpg?stp=dst-jpg_tt6&cstp=mx960x720&ctp=s960x720&_nc_cat=105&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=0otwqG9zWc8Q7kNvwEpS4LZ&_nc_oc=AdrHH4Fk0xAMoZzpcmGQCqb78OZFZfyW7aRi5mApODFIxsX1ezmDSQNjBGOciHTnRTcdheBiVjKtjP8dPBX5YOcf&_nc_zt=23&_nc_ht=scontent-den2-1.xx&_nc_gid=JQzxDqfPtkzW7eGLYL8K9Q&_nc_ss=7b2a8&oh=00_AQEf0mHfWbaNiMtoPUuSykbKy-8N-nTnRzR7cvBPkB38zg&oe=6A848519',
      features: ['History', 'Cultural', 'Free Entry'],
      url: "https://www.facebook.com/CCCPOWCAMPUT/?_rdr"
    },
    
    {
      name: "Redmond Minerals Salt Mine",
      description:
        "Tour a maze of ancient salt tunnels hundreds of feet underground — a unique Central Utah experience.",
      distance: "1 minute",
      duration: "60-90 minutes",
      cost: "$30/person",
      rating: 5,
      image: 'https://www.visitutah.com/azure/cmsroot/visitutah/media/site-assets/three-season-photography/central-utah/redmond-real-salt_redmond_mine-outside_heber_diamond-austen_2020.jpg?w=1160&h=754&mode=crop&quality=65',
      features: ['Rodeo', 'Family Fun'],
      url: "https://lp.redmondminerals.com/tour"
    }
  ];

  const activities = [
    {
      title: "Hiking & Nature Walks",
      description:
        "Enjoy peaceful hikes at nearby Blackhawk Mountain or explore the Gooseberry Trail for forest views and fresh mountain air.",
      icon: <Mountain size={24} />,
    },
    {
      title: "Historic Main Street",
      description:
        "Stroll through downtown Salina’s historic Main Street, grab a bite at Mom’s Café, and experience the charm of a classic Utah town.",
      icon: <Camera size={24} />,
    },
    {
      title: "ATV & Off-Roading Trails",
      description:
        "Ride through the scenic Fishlake National Forest or hit the famous Arapeen Trail System right from town.",
      icon: <TreePine size={24} />,
    },
    {
      title: 'Big Rock Candy Mountain',
      description: 'take a short drive to the colorful canyons of Big Rock Candy Mountain.',
      icon: <Mountain size={24} />
    }
  ];

  return (
    <div className="attractions">
      {/* Hero Section */}
      <section className="attractions-hero">
        <div className="attractions-hero-background">
          <div className="attractions-hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div
            className="attractions-hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Local Attractions</h1>
            <p>
              Discover the hidden gems, scenic landscapes, and unforgettable
              experiences surrounding High Desert Inn in Salina, Utah.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Activities Section */}
      <section className="section activities-section">
        <div className="container">
          <motion.div
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>Popular Activities</h2>
            <p>
              From outdoor adventures to small-town charm, there's something for
              everyone in Salina, Utah.
            </p>
          </motion.div>

          <div className="activities-grid">
            {activities.map((activity, index) => (
              <motion.div
                key={index}
                className="activity-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
              >
                <div className="activity-icon">{activity.icon}</div>
                <h3>{activity.title}</h3>
                <p>{activity.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Attractions Grid */}
      <section className="section attractions-grid-section">
        <div className="container">
          <motion.div
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>Nearby Attractions</h2>
            <p>
              Explore the best attractions and experiences the desert has to
              offer.
            </p>
          </motion.div>

          <div className="attractions-grid">
            {attractions.map((attraction, index) => (
              <motion.div
                onClick={() => window.open(attraction.url, "_blank")}              
                key={index}
                className="attraction-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
              >
                <div className="attraction-image">
                  <img src={attraction.image} alt={attraction.name} />
                  <div className="attraction-rating">
                    {[...Array(Math.floor(attraction.rating))].map((_, i) => (
                      <Star key={i} size={16} fill="currentColor" />
                    ))}
                  </div>
                </div>
                <div className="attraction-content">
                  <h3>{attraction.name}</h3>
                  <p>{attraction.description}</p>

                  <div className="attraction-details">
                    <div className="detail-item">
                      <MapPin size={16} />
                      <span>{attraction.distance}</span>
                    </div>
                    {attraction.duration?.trim() && (
                      <div className="detail-item">
                        <Clock size={16} />
                        <span>{attraction.duration}</span>
                      </div>
                    )}
                    {attraction.cost?.trim() && (
                      <div className="detail-item">
                        <DollarSign size={16} />
                        <span>{attraction.cost}</span>
                      </div>
                    )}
                  </div>

                  <div className="attraction-features">
                    {attraction.features.map((feature, featureIndex) => (
                      <span key={featureIndex} className="feature-tag">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Attractions;
